import { Divider, Stack, Tab, Tabs, Typography, styled } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/auth';
import { Role } from 'const/common';
import { Icon_Arrow } from 'assets';
import { SETTINGS_BASE_PATH, SETTINGS_TABS } from '../const';

type SettingsShellProps = {
  activeTabPath: string;
  breadcrumbLabel?: string;
  children: React.ReactNode;
};

export const SettingsShell = ({ activeTabPath, breadcrumbLabel, children }: SettingsShellProps) => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const isAdmin = auth?.role === Role.SUPER_ADMIN || auth?.role === Role.ADMIN;

  const visibleTabs = SETTINGS_TABS.filter((tab) => !tab.restricted || isAdmin);
  const activeIndex = Math.max(
    visibleTabs.findIndex((tab) => tab.path === activeTabPath),
    0
  );

  return (
    <WrapperPage>
      <BreadcrumbRow direction="row" alignItems="center" spacing={1.5}>
        <TextPath onClick={() => navigate(SETTINGS_BASE_PATH)}>Path:</TextPath>
        <TextPath
          active={!breadcrumbLabel ? 'active' : undefined}
          onClick={() => navigate(SETTINGS_BASE_PATH)}>
          Settings
        </TextPath>
        {breadcrumbLabel && (
          <>
            <Icon_Arrow color="#226AAA" />
            <TextPath active="active">{breadcrumbLabel}</TextPath>
          </>
        )}
      </BreadcrumbRow>

      <TitleStyled>Settings</TitleStyled>

      <Tabs
        value={activeIndex}
        onChange={(_, index) => navigate(`${SETTINGS_BASE_PATH}/${visibleTabs[index].path}`)}
        sx={{
          minHeight: 44,
          '& .MuiTab-root': {
            fontSize: 13,
            fontWeight: 700,
            letterSpacing: 0.3,
            color: '#728197',
            minHeight: 44,
            padding: '10px 18px'
          },
          '& .Mui-selected': { color: '#1769C2 !important' },
          '& .MuiTabs-indicator': { backgroundColor: '#1769C2', height: 2 }
        }}>
        {visibleTabs.map((tab) => (
          <Tab key={tab.path} label={tab.label} />
        ))}
      </Tabs>
      <Divider sx={{ borderColor: '#E4E8EE', mb: 3 }} />

      {children}
    </WrapperPage>
  );
};

const WrapperPage = styled(Stack)(() => ({
  width: '100%',
  minHeight: '100vh',
  padding: '28px 40px 48px',
  backgroundColor: '#FFFFFF'
}));

const BreadcrumbRow = styled(Stack)(() => ({
  marginBottom: 8
}));

const TextPath = styled(Typography)(({ active }: { active?: string }) => ({
  fontSize: '14px',
  fontWeight: active === 'active' ? 700 : 400,
  color: active === 'active' ? '#226AAA' : '#818181',
  cursor: 'pointer',
  textDecoration: 'none'
}));

const TitleStyled = styled(Typography)(() => ({
  color: '#226AAA',
  fontSize: '32px',
  fontWeight: 900,
  marginBottom: 20
}));
